/**
 * @author        woody@zumper.com (Woody Anderson), yewon@zumper.com(Yewon Lee)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   Fetcher Singleton
 */

import fetcherFactory from './fetcher'

export default fetcherFactory()
